module.exports = __webpack_public_path__ + "img/list7.5115125a.png";